import { render, staticRenderFns } from "./TransferInstructionGamepass.vue?vue&type=template&id=09f81e52&"
import script from "./TransferInstructionGamepass.vue?vue&type=script&lang=js&"
export * from "./TransferInstructionGamepass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports